export const PaymentOverlayCompletionStatuses = {
    SUCCESS: 'success',
    FAIL: 'fail',
};
